import React from "react";

function Error() {
  return (
    <div className="error">
      <h1>404 | Page not found</h1>
      <a href="/">Home</a>
    </div>
  );
}

export default Error;
